import { ChevronLeft, ChevronRight, MoreHorizontal, Smile, X } from 'lucide-react'
import TooltipOverlay from '@/components/TooltipOverlay'

interface ThreadHeaderProps {
  onClose: () => void
  onPrevious?: () => void
  onNext?: () => void
  onAddReaction?: () => void
  onMenu?: () => void
  hasPrevious?: boolean
  hasNext?: boolean
  showNavigation?: boolean
}

const ThreadHeader = ({
  onClose,
  onPrevious,
  onNext,
  onAddReaction,
  onMenu,
  hasPrevious = false,
  hasNext = false,
  showNavigation = true,
}: ThreadHeaderProps) => {
  return (
    <div
      className="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-dark-border"
    >
      {/* Navigation Controls */}
      {showNavigation && (
        <div className="flex items-center gap-1">
          <TooltipOverlay message="Previous thread">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation()
                onPrevious?.()
              }}
              disabled={!hasPrevious}
              className="p-1.5 rounded hover:bg-gray-100 dark:hover:bg-dark-accent transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
            >
              <ChevronLeft size={18} className="text-gray-600 dark:text-gray-400" />
            </button>
          </TooltipOverlay>
          <TooltipOverlay message="Next thread">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation()
                onNext?.()
              }}
              disabled={!hasNext}
              className="p-1.5 rounded hover:bg-gray-100 dark:hover:bg-dark-accent transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
            >
              <ChevronRight size={18} className="text-gray-600 dark:text-gray-400" />
            </button>
          </TooltipOverlay>
        </div>
      )}

      {/* Right Actions */}
      <div className="flex items-center gap-1 ml-auto">
        {onAddReaction && (
          <TooltipOverlay message="Add reaction">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation()
                onAddReaction()
              }}
              className="p-1.5 rounded hover:bg-gray-100 dark:hover:bg-dark-accent transition-colors"
            >
              <Smile size={18} className="text-gray-600 dark:text-gray-400" />
            </button>
          </TooltipOverlay>
        )}
        {onMenu && (
          <TooltipOverlay message="More options">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation()
                onMenu()
              }}
              className="p-1.5 rounded hover:bg-gray-100 dark:hover:bg-dark-accent transition-colors"
            >
              <MoreHorizontal size={18} className="text-gray-600 dark:text-gray-400" />
            </button>
          </TooltipOverlay>
        )}
        <TooltipOverlay message="Close">
          <button
            type="button"
            onPointerDown={(e) => {
              e.preventDefault()
              e.stopPropagation()
              onClose()
            }}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              onClose()
            }}
            className="p-1.5 rounded hover:bg-gray-100 dark:hover:bg-dark-accent transition-colors"
          >
            <X size={18} className="text-gray-600 dark:text-gray-400" />
          </button>
        </TooltipOverlay>
      </div>
    </div>
  )
}

export default ThreadHeader
